export default {
    InternalSalesOrderDetailsSearchTable: {
        provider: '承运方',
        totalPrice: '总运费',
        totalGst: '税费',
        freightCharge: '运费',
        fuelCharge: '燃油附加费',
        labelType: '运送方式',
        labelColour: '运送类型',
        responseCode: '询价状态',
        failReason: '失败原因',
        creationDate: '日期',
        status: '状态',
        push: '重新推送',
        Fix: '修正异常单',
        Select: '请选择修正方式',
        Requote: '重新询价',
        Choose: '指定物流公司',
        Confirm: '您是否确认将当前订单 ',

        providerss: '承运物流公司',
        totalPricess: '承运物流业务',
    }
};
